import { Component, Input, OnInit } from '@angular/core';
import { Chart } from 'chart.js';
import { CloudData, CloudOptions } from 'angular-tag-cloud-module';
import { extractCombinations, render } from '@upsetjs/bundle';

@Component({
	selector: 'app-importunation-data',
	templateUrl: './importunation-data.component.html',
	styleUrls: ['./importunation-data.component.scss'],
})
export class ImportunationDataComponent implements OnInit {
	@Input() dataAgressions: any;
	@Input() elId: string;

	constructor() {}

	ngOnInit(): void {
		this.createGraphWordCloud();
		this.createGraphCasesOfSublocality();
		this.terra();
	}

	ngOnChanges(): void {
		this.createGraphWordCloud();
		this.createGraphCasesOfSublocality();
		this.terra();
	}

	dataCloud: CloudData[] = [];
	optionsCloud: CloudOptions = {};
	colors = ['#5CDBBD', '#180064', '#2C009E', '#5B43D9'];
	dataSetOfsublocality = [];
	noData = false;

	createGraphWordCloud() {
		this.dataCloud = [];

		this.optionsCloud = {
			overflow: true,
		};

		let words = this.dataAgressions?.word_count;

		let arrayDeWords = [];
		if (words && Object.keys(words).length) {
			this.noData = false;
			for (const chave in words) {
				arrayDeWords.push({ word: chave, count: words[chave] });
			}
		} else {
			this.noData = true;
		}

		arrayDeWords = arrayDeWords.sort((a, b) => b.count - a.count).slice(0, 99);

		if (arrayDeWords.length) {
			arrayDeWords.forEach((word: any) => {
				this.dataCloud.push({
					text: word.word,
					weight: word.count,
					color: this.escolherCorAleatoria([
						'#180064',
						'#8F7FFF',
						'#5B43D9',
						'#3ABFA2',
						'#382D75',
					]),
				});
			});
		}
	}

	agressoresChart: Chart | null = null;
	createGraphWhoAreMyAgressors() {
		let key = [];
		let value = [];
		const canvas = document.getElementById(
			'myChartWhoAreAgressors'
		) as HTMLCanvasElement;
		const ctx = canvas.getContext('2d');
		let dados = this.dataAgressions?.category_counts?.perpetrator;
		if (dados) key = Object.keys(dados);
		if (dados) value = Object.values(dados);
		let color = ['#5CDBBD', '#180064', '#2C009E', '#5B43D9'];

		let datas = [];

		key.forEach((element, index) => {
			datas.push({
				label: key[index],
				data: [value[index]],
				backgroundColor: color[index], // Cor para a categoria 'Motorista'
				barPercentage: 0.6,
				categoryPercentage: 0.8,
			});
		});

		var data = {
			labels: [''],
			datasets: datas,
		};

		if (this.agressoresChart) this.agressoresChart.destroy();

		this.agressoresChart = new Chart(ctx, {
			type: 'bar',
			data: data,
			options: {
				responsive: true,

				legend: {
					display: false,
					position: 'bottom', // Posição da legenda
					align: 'center', // Alinhamento da legenda
					labels: {
						usePointStyle: false, // Usar estilo de ponto (cor do item da legenda)
						boxWidth: 12, // Tamanho da caixa da legenda
						fontColor: '#938F94', // Cor da fonte da legenda
					},
				},
				scales: {
					xAxes: [
						{
							ticks: {
								beginAtZero: true,
							},
							gridLines: {
								display: false,
							},
						},
					],
					yAxes: [
						{
							ticks: {
								beginAtZero: true,
								fontColor: '#938F94',
							},
							gridLines: {
								color: 'rgba(229,222,255)', // Cor do grid x
								borderDash: [10, 5], // Padrão de traço (5 pixels sólidos, 5 pixels vazios)
								borderDashOffset: 10, // Deslocamento do padrão de traço
								drawBorder: false, // Não desenhar a borda do gráfico
								//drawOnChartArea: false, // Não desenhar sobre a área do gráfico
								drawTicks: false, // Não desenhar os ticks,
								zeroLineColor: 'rgba(229,222,255)', // Cor da linha zero
								zeroLineBorderDash: [10, 5], // Padrão de traço da linha zero
								zeroLineBorderDashOffset: 10, // Deslocamento do padrã
							},
						},
					],
				},
			},
		});
	}

	sublocalityChart: Chart | null = null;
	noSublocalityData: boolean = false;
	createGraphCasesOfSublocality() {
		const sublocalityPercentages =
			this.dataAgressions?.category_counts_percentage.sublocality || {};

		this.dataSetOfsublocality = [];
		const canvas = document.getElementById(
			this.elId + 'myChartCasesPerSublocality'
		) as HTMLCanvasElement;
		const ctx = canvas.getContext('2d');

		let sublocalidadeInf =
			this.dataAgressions?.category_counts?.sublocality || {};

		if (Object.keys(sublocalidadeInf).length === 0) {
			this.noSublocalityData = true;
			return;
		}

		let naoInformado = sublocalidadeInf
			? sublocalidadeInf['Não informado']
			: null;
		delete sublocalidadeInf['Não informado'];
		sublocalidadeInf['Não informado'] = naoInformado;

		if (sublocalidadeInf) {
			sublocalidadeInf = Object.entries(sublocalidadeInf).map(
				([cidade, acidentes]) => ({ cidade, acidentes })
			);

			sublocalidadeInf.sort((a, b) => b.acidentes - a.acidentes);

			sublocalidadeInf = sublocalidadeInf
				.slice(0, 5)
				.reduce((obj, { cidade, acidentes }) => {
					obj[cidade] = acidentes;
					return obj;
				}, {});
			let key = [];
			let value = [];
			key = Object.keys(sublocalidadeInf);
			value = Object.values(sublocalidadeInf);
			let color = ['#AEAAAE', '#5CDBBD', '#180064', '#2C009E', '#5B43D9'];

			let datas = [];
			key.forEach((element, index) => {
				datas.push({
					label: key[index],
					data: [value[index]],
					backgroundColor: color[index % 5],
					barPercentage: 0.6,
					categoryPercentage: 0.8,
				});
			});

			this.dataSetOfsublocality = datas;

			this.dataSetOfsublocality.push(this.dataSetOfsublocality.shift());

			var data = {
				labels: [''],
				datasets: this.dataSetOfsublocality,
			};

			if (this.sublocalityChart) this.sublocalityChart.destroy();

			this.sublocalityChart = new Chart(ctx, {
				type: 'bar',
				data: data,
				options: {
					tooltips: {
						callbacks: {
							label: function (tooltipItem, data) {
								return `${data.datasets[tooltipItem.datasetIndex].label}: ${
									tooltipItem.yLabel
								} (${
									sublocalityPercentages[
										data.datasets[tooltipItem.datasetIndex].label
									]
								})`;
							},
						},
					},
					responsive: true,

					legend: {
						display: false,
						position: 'bottom', // Posição da legenda
						align: 'center', // Alinhamento da legenda
						labels: {
							usePointStyle: false, // Usar estilo de ponto (cor do item da legenda)
							boxWidth: 12, // Tamanho da caixa da legenda
							fontColor: '#938F94', // Cor da fonte da legenda
						},
					},
					scales: {
						xAxes: [
							{
								ticks: {
									beginAtZero: true,
								},
								gridLines: {
									display: false,
								},
							},
						],
						yAxes: [
							{
								ticks: {
									beginAtZero: true,
									fontColor: '#938F94',
								},
								gridLines: {
									color: 'rgba(229,222,255)', // Cor do grid x
									borderDash: [10, 5], // Padrão de traço (5 pixels sólidos, 5 pixels vazios)
									borderDashOffset: 10, // Deslocamento do padrão de traço
									drawBorder: false, // Não desenhar a borda do gráfico
									//drawOnChartArea: false, // Não desenhar sobre a área do gráfico
									drawTicks: false, // Não desenhar os ticks,
									zeroLineColor: 'rgba(229,222,255)', // Cor da linha zero
									zeroLineBorderDash: [10, 5], // Padrão de traço da linha zero
									zeroLineBorderDashOffset: 10, // Deslocamento do padrã
								},
							},
						],
					},
				},
			});
		}
	}

	createGraphTypeOcurrence() {
		const canvas = document.getElementById(
			'myChartTypeOcurrence'
		) as HTMLCanvasElement;
		const ctx = canvas.getContext('2d');

		let tipoAgressao = this.dataAgressions?.category_counts?.type;

		if (tipoAgressao) {
			tipoAgressao = {};
		} else {
			tipoAgressao = {
				intimidacao: 0,
				encoxar: 0,
				seTocar: 0,
				perseguicao: 0,
				fotosIndesejadas: 0,
				outros: 0,
			};
		}

		var data = {
			labels: [
				'Intimidação',
				'Encoxar/Tatear',
				'Se tocar/Exibir',
				'Perseguição',
				'Fotos indesejadas',
				'Outros',
			],
			datasets: [
				{
					data: [
						tipoAgressao.intimidacao,
						tipoAgressao.encoxar,
						tipoAgressao.seTocar,
						tipoAgressao.perseguicao,
						tipoAgressao.fotosIndesejadas,
						tipoAgressao.outros,
					], // Valores dos bs
					backgroundColor: [
						'#2C009E',
						'#5B43D9',
						'#180064',
						'#3ABFA2',
						'#B8FFE9',
						'#F3EEFF',
					], // Cores das fatias
					borderColor: 'white', // Cor da borda das fatias
					borderWidth: 2, // Largura da borda das fatias
				},
			],
		};

		var myChart = new Chart(ctx, {
			type: 'doughnut',
			data: data,
			options: {
				cutoutPercentage: 50, // Define a porcentagem de recorte para criar o gráfico de rosquinha
				responsive: true, // Desabilita a responsividade do gráfico},
				legend: {
					display: false,
				},
			},
		});
	}

	escolherCorAleatoria(paletaDeCores) {
		const indiceAleatorio = Math.floor(Math.random() * paletaDeCores.length);
		return paletaDeCores[indiceAleatorio];
	}

	// Função para transformar a base de dados
	transformarBaseDeDados(base) {
		const resultado = [];

		for (const item of base) {
			const elementos = item[0].split(', ');

			if (elementos.length === 1) {
				// Se a lista original contém apenas um elemento, cria um novo elemento na lista
				resultado.push({ name: elementos[0], sets: [elementos[0]] });
			} else {
				// Caso contrário, mantém a estrutura original
				resultado.push({ name: item[0], sets: elementos });
			}
		}

		return resultado;
	}

	noTypesData = false;
	terra() {
		let lista = [];
		let tipoAgressao = this.dataAgressions?.types_list;

		const uniqueValues = [...new Set(tipoAgressao.flat())];
		const count = uniqueValues.length;

		if (tipoAgressao && tipoAgressao.length > 0 && count > 1) {
			tipoAgressao.forEach((element: any) => {
				lista.push({ name: element.join(', '), sets: element });
			});
		} else {
			this.noTypesData = true;
			return;
		}
		let selection = null;
		const colors = [
			'#180064',
			'#2C009E',
			'#5B43D9',
			'#8F7FFF',
			'#5CDBBD',
			'#3ABFA2',
		];

		let { sets, combinations } = extractCombinations(lista);

		sets = sets.map((s, i) => ({ ...s, color: colors[i % 6] }));

		combinations = combinations.map((c, i) => ({ ...c, color: colors[i % 6] }));

		render(document.body.querySelector('#' + this.elId), {
			sets,
			combinations,
			width: 1300,
			height: 600,
		});

		let identificador = document.body
			.querySelector('#' + this.elId)
			.querySelector('svg')
			.classList.value.split('-')[2];
		let listaLinha = document.getElementsByClassName(
			'axisLine-upset-' + identificador
		);

		for (var i = 0; i < listaLinha.length; i++) {
			listaLinha.item(i)['style'].display = 'none';
		}

		let listaTexto = document.getElementsByClassName(
			'axisTextStyle-upset-' + identificador
		);
		for (var i = 0; i < listaTexto.length; i++) {
			listaTexto.item(i)['style'].display = 'none';
		}

		document.querySelector('.exportButtons-upset-' + identificador)![
			'style'
		].display = 'none';
		document.querySelector('.cChartTextStyle-upset-' + identificador)![
			'style'
		].display = 'none';
		document.querySelector('.sChartTextStyle-upset-' + identificador)![
			'style'
		].display = 'none';
		//document.querySelector('.axisLine-upset-'+identificador)!['style'].display = 'none'

		function onHover(set) {
			selection = set;
			rerender();
		}

		function rerender() {
			const props = {
				sets,
				combinations,
				width: 1300,
				height: 600,
				selection,
				onHover,
			};
			render(document.body.querySelector('#' + this.elId), props);
		}

		rerender();
	}
}
